import { render, staticRenderFns } from "./Make.vue?vue&type=template&id=528795c4&scoped=true"
import script from "./Make.vue?vue&type=script&lang=js"
export * from "./Make.vue?vue&type=script&lang=js"
import style0 from "./Make.vue?vue&type=style&index=0&id=528795c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528795c4",
  null
  
)

export default component.exports